import { Theme } from '@mui/material/styles';

export const HOME_SEGMENT_DIMENSIONS =(theme: Theme) => ( {
	BORDER_BOTTOM: `thin solid ${theme.custom.disabledColor}`,
	TITLE: {
		HEIGHT: 48,
	},
});
